interface PageHeaderProps {
  title: string;
}

export const PageHeader = ({ title }: PageHeaderProps) => {
  return (
    <div className="mb-8 mt-8">
      <h1 className="text-2xl font-bold w-1/4 text-center">{title}</h1>
    </div>
  );
};
